// extracted by mini-css-extract-plugin
module.exports = {"table-container":"UserTable_table-container__2LgHu","edit-button":"UserTable_edit-button__3rsH0"};